module.exports = __webpack_public_path__ + "static/media/study 201103.52eca8a6.png";